// mismos cafe + Rolls hub data

export const CAFE_INFO = {
  name: "mismos",
  tagline: "Your Daily Dose of Chill",
  logo: "/assets/logo.jpg",
  address: "Mysore-Bangalore Road, Bannimantap, Mysore-570015",
  phone: "+91 77361 78517",
  email: "mail.mismos@gmail.com",
  hours: [
    { day: "Monday – Thursday", time: "10:00 AM – 11:30 PM" },
    { day: "Friday – Sunday", time: "10:00 AM – 12:30 AM" },
  ],
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
  },
  mapsQuery:
    "mismos, Mysore-Bangalore Road, Bannimantap, Mysore 570015",
};

// WhatsApp deep link used by all "Order Now" / "Reserve" CTAs
const WHATSAPP_NUMBER = "917736178517"; // +91 77361 78517
const RESERVE_MSG = encodeURIComponent(
  "Hi mismos! I'd like to reserve a table.\n\nName:\nDate:\nTime:\nGuests:",
);
const ORDER_MSG = encodeURIComponent(
  "Hi mismos! I'd like to place an order.\n\nItems:\nPickup/Delivery:\nName:",
);
export const WHATSAPP_RESERVE_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${RESERVE_MSG}`;
export const WHATSAPP_ORDER_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${ORDER_MSG}`;

// Uploaded assets
export const IMAGES = {
  storefront: "/assets/storefront.png",
  rollDisplay: "/assets/roll-display.png",
  rollHero: "/assets/roll-hero.png",
};

// MAIN MENU (mismos)
export const MENU = [
  {
    category: "Avil Milk",
    blurb: "Cooled, frothy milk infusions — the mismos signature.",
    note: "Avil Milk parcel extra ₹5/-",
    items: [
      { name: "Normal", price: 40 },
      { name: "Boost", price: 50 },
      { name: "Mango", price: 70 },
      { name: "Strawberry", price: 70 },
      { name: "Fruits", price: 70 },
      { name: "Pista", price: 70 },
      { name: "Badam", price: 80 },
      { name: "Dates", price: 80 },
      { name: "Dry Fruits", price: 80 },
      { name: "Fruit & Nuts", price: 80 },
      { name: "Chocolate", price: 80 },
      { name: "Tender Coconut", price: 90 },
      { name: "Nuts", price: 90 },
      { name: "Royal", price: 120 },
      { name: "Nutella Nut", price: 120 },
      { name: "Avocado Nut", price: 120 },
      { name: "Rio Nut", price: 120 },
      { name: "Honey Fig", price: 120 },
    ],
  },
  {
    category: "Milk Shakes",
    blurb: "Hand-blended shakes, whole milk, real fruit.",
    items: [
      { name: "Mango", price: 60 },
      { name: "Papaya", price: 50 },
      { name: "Strawberry", price: 70 },
      { name: "Apple", price: 70 },
      { name: "Chikku", price: 60 },
      { name: "Sharja", price: 60 },
      { name: "Anar", price: 70 },
      { name: "Tender Coconut", price: 80 },
      { name: "Avocado", price: 70 },
      { name: "Dry Fruit", price: 80 },
      { name: "Cold Coffee", price: 50 },
      { name: "Cold Boost", price: 60 },
      { name: "Cold Horlicks", price: 60 },
      { name: "Naruneendi Milk Sarbath", price: 50 },
    ],
  },
  {
    category: "Ice Cream Shakes",
    blurb: "Scoop-loaded indulgence, served thick.",
    items: [
      { name: "Oreo", price: 70 },
      { name: "Snickers", price: 100 },
      { name: "Kitkat", price: 90 },
      { name: "Mango", price: 90 },
      { name: "Vanilla", price: 80 },
      { name: "Nutella", price: 120 },
      { name: "Lotus", price: 140 },
      { name: "Chocolate", price: 90 },
      { name: "Pista", price: 90 },
      { name: "Strawberry", price: 90 },
      { name: "Tender Coconut", price: 120 },
    ],
  },
  {
    category: "Arabic Specials",
    blurb: "Inspired by the souks — bold, fragrant, smooth.",
    items: [
      { name: "Abood", price: 100 },
      { name: "Mango Passion", price: 100 },
      { name: "Awar Qalb", price: 110 },
      { name: "Avocado Super", price: 100 },
      { name: "Avocado Nuts", price: 100 },
      { name: "Avocado Shaqaf", price: 120 },
    ],
  },
  {
    category: "Lassi",
    blurb: "Yogurt classics — cooling, clean, comforting.",
    items: [
      { name: "Sweet Lassi", price: 50 },
      { name: "Strawberry", price: 60 },
      { name: "Mango", price: 60 },
      { name: "Apple", price: 60 },
      { name: "Fruit Lassi", price: 70 },
    ],
  },
  {
    category: "Mojito",
    blurb: "Fizzy, herbed, served over crushed ice.",
    items: [
      { name: "Virgin Mojito", price: 80 },
      { name: "Passion Fruit", price: 80 },
      { name: "Pineapple", price: 80 },
      { name: "Blue Caraco", price: 90 },
      { name: "Strawberry", price: 80 },
      { name: "Green Apple", price: 80 },
      { name: "Mango", price: 80 },
      { name: "Blue Berry", price: 90 },
      { name: "Black Current", price: 90 },
      { name: "Guava", price: 80 },
      { name: "Watermelon", price: 80 },
      { name: "Litchee", price: 80 },
      { name: "Orange", price: 80 },
      { name: "Pomegranate", price: 80 },
      { name: "Pineapple Chilli", price: 100 },
      { name: "Mango Chilli", price: 100 },
      { name: "Passion Chilli", price: 100 },
      { name: "Pacha Manga Kandhari", price: 80 },
      { name: "Nellika Kandhari", price: 80 },
    ],
  },
  {
    category: "Falooda",
    blurb: "Layered, dressed and quietly extravagant.",
    items: [
      { name: "Regular Falooda", price: 100 },
      { name: "Fancy Falooda", price: 120 },
      { name: "Chocolate Falooda", price: 140 },
      { name: "King Falooda", price: 190 },
      { name: "Royal Falooda", price: 160 },
      { name: "Dry Fruit Falooda", price: 170 },
      { name: "Strawberry Falooda", price: 120 },
      { name: "Mango Falooda", price: 120 },
      { name: "Pista Falooda", price: 120 },
      { name: "Black Beauty", price: 120 },
      { name: "American Sundae", price: 140 },
      { name: "Gud Bud", price: 120 },
      { name: "Fruit Salad", price: 80 },
      { name: "Royal Fruit Salad", price: 120 },
    ],
  },
  {
    category: "Monster",
    blurb: "Stacked, towering and shareable.",
    items: [
      { name: "Nutella Monster", price: 180 },
      { name: "Snickers Monster", price: 160 },
      { name: "Mango Monster", price: 160 },
      { name: "Tender Monster", price: 160 },
      { name: "Chocolate Monster", price: 140 },
      { name: "Strawberry Monster", price: 140 },
      { name: "Oreo Monster", price: 140 },
      { name: "Kitkat Monster", price: 140 },
      { name: "Pista Monster", price: 140 },
    ],
  },
  {
    category: "Starters",
    blurb: "Crispy bites — hot from the fryer.",
    items: [
      { name: "French Fries", price: 60 },
      { name: "Peri Peri Fries", price: 90 },
      { name: "Cheese Fries", price: 90 },
      { name: "Cheese Corn", price: 100 },
      { name: "Chicken Popcorn", price: 80 },
      { name: "Chicken Fingers", price: 100 },
      { name: "Veggie Fingers", price: 100 },
      { name: "Falafil", price: 80 },
      { name: "Nuggets (Veg / Ckn)", price: 80 },
      { name: "Wedges", price: 60 },
    ],
  },
  {
    category: "Mismos Special",
    blurb: "Loaded, saucy, unapologetically indulgent.",
    items: [
      { name: "Chicken Loaded Fries", price: 140 },
      { name: "Chicken Peri Peri Loaded Fries", price: 160 },
      { name: "Chicken Special Loaded Fries", price: 170 },
      { name: "Pasta Chicken Loaded", price: 160 },
      { name: "Pasta Chicken", price: 100 },
      { name: "Veg Loaded Fries", price: 140 },
      { name: "Veg Peri Peri Loaded Fries", price: 160 },
      { name: "Veg Special Loaded Fries", price: 170 },
      { name: "Pasta Veg Loaded", price: 160 },
      { name: "Pasta Veg", price: 100 },
    ],
  },
  {
    category: "Club Sandwich",
    blurb: "Triple-decker stacks for serious appetites.",
    items: [
      { name: "Chicken Club", price: 140 },
      { name: "Zinger Club", price: 160 },
      { name: "Chicken 65 Club", price: 150 },
      { name: "Nuggets Chicken Club", price: 140 },
      { name: "Hotdog Club", price: 140 },
      { name: "Mega Club", price: 140 },
      { name: "Egg Club", price: 130 },
      { name: "Chicken Family Club", price: 299 },
      { name: "Veg Family Club", price: 299 },
      { name: "Veg Club", price: 140 },
      { name: "Falafil Club", price: 140 },
      { name: "Nuggets Veg Club", price: 140 },
    ],
  },
  {
    category: "Momo",
    blurb: "Steamed, fried or cheesy — plump and addictive.",
    items: [
      { name: "Fried Chicken Momo", price: 80 },
      { name: "Steamed Chicken Momo", price: 80 },
      { name: "Cheesy Chicken Momo", price: 140 },
      { name: "Cheesy Peri Peri Chicken Momo", price: 160 },
      { name: "Fried Veg Momo", price: 80 },
      { name: "Steamed Veg Momo", price: 80 },
      { name: "Cheesy Veg Momo", price: 140 },
      { name: "Cheesy Peri Peri Veg Momo", price: 160 },
    ],
  },
  {
    category: "Burger",
    blurb: "Toasted brioche, fresh fillings, house sauces.",
    items: [
      { name: "Chicken Burger", price: 100 },
      { name: "Chicken 65 Burger", price: 120 },
      { name: "Zinger Burger", price: 120 },
      { name: "Mega Zinger Burger", price: 160 },
      { name: "Double Decker Chicken Burger", price: 150 },
      { name: "Mix Burger (Veg / Ckn)", price: 120 },
      { name: "Nuggets Chicken Burger", price: 100 },
      { name: "Mexican Chicken Burger", price: 160 },
      { name: "Veg Burger", price: 90 },
      { name: "Falafal Burger", price: 90 },
      { name: "Double Decker Veg Burger", price: 150 },
      { name: "Nuggets Veg Burger", price: 100 },
      { name: "Mexican Veg Burger", price: 160 },
    ],
  },
  {
    category: "Sandwich",
    blurb: "Pressed, crisp, satisfyingly simple.",
    items: [
      { name: "Chicken Sandwich", price: 70 },
      { name: "Zinger Sandwich", price: 90 },
      { name: "Popcorn Sandwich", price: 80 },
      { name: "Chicken 65 Sandwich", price: 70 },
      { name: "HotDog Sandwich", price: 60 },
      { name: "Nuggets Chicken Sandwich", price: 70 },
      { name: "Egg Sandwich", price: 60 },
      { name: "Veg Sandwich", price: 60 },
      { name: "Falafel Sandwich", price: 70 },
      { name: "Nuggets Veg Sandwich", price: 70 },
      { name: "Nutella Sandwich", price: 80 },
    ],
  },
  {
    category: "Protein Diet (No Sugar)",
    blurb: "Clean fuel — honey-sweetened, nut-powered.",
    items: [
      { name: "Avo Punch", desc: "Avocado + Honey + Nuts + Milk", price: 120 },
      { name: "Peanuts Punch", desc: "Peanut + Honey + Nuts + Date + Milk", price: 120 },
      { name: "Rova Punch", desc: "Banana + Honey + Nuts + Milk", price: 120 },
      { name: "Waccado Punch", desc: "Walnuts + Honey + Nuts + Milk", price: 140 },
      { name: "Dravio Punch", desc: "Fig + Honey + Apple + Nuts + Milk", price: 140 },
    ],
  },
];

// ROLLS MENU (mismos Rolls — Juice Hub side). Only unique sections not on main menu.
export const ROLLS_MENU = [
  {
    category: "Chicken Rolls",
    blurb: "Fresh, hand-rolled, loaded with our signature filling.",
    items: [
      { name: "Chicken Roll", price: 110 },
      { name: "Chicken Spl Roll", price: 130 },
      { name: "Chicken Crispy Roll", price: 130 },
      { name: "Jumbo Chicken Roll", price: 140 },
      { name: "Pepper Chicken Roll", price: 110 },
      { name: "Chilly Crispy Mix", price: 130 },
      { name: "Falafel Chicken Roll", price: 130 },
      { name: "Falafel Egg Chicken Roll", price: 140 },
      { name: "Spicy Chicken Roll", price: 110 },
      { name: "Crispy Spicy Mix", price: 130 },
      { name: "Egg Roll", price: 100 },
    ],
  },
  {
    category: "Veg Rolls",
    blurb: "Crunchy, cheesy, comfort in a wrap.",
    items: [
      { name: "Veg Spl Roll", price: 100 },
      { name: "Veg Crispy Roll", price: 110 },
      { name: "Cheese Corn Roll", price: 100 },
      { name: "Falafel Roll", price: 100 },
      { name: "Paneer Roll", price: 110 },
      { name: "Veg Mix Jumbo", price: 130 },
    ],
  },
  {
    category: "Fresh Juice",
    blurb: "Cold-pressed, straight from the fruit.",
    items: [
      { name: "Mosambi", price: 50 },
      { name: "Orange", price: 50 },
      { name: "Watermelon", price: 50 },
      { name: "Mango", price: 60 },
      { name: "Papaya", price: 50 },
      { name: "Anar", price: 70 },
      { name: "Pineapple", price: 50 },
      { name: "Strawberry", price: 70 },
    ],
  },
  {
    category: "Pure Juice",
    blurb: "No water, no sugar — just the fruit.",
    items: [
      { name: "Orange", price: 100 },
      { name: "Mosambi", price: 100 },
      { name: "Pineapple", price: 100 },
      { name: "Watermelon", price: 60 },
      { name: "Grape", price: 100 },
    ],
  },
  {
    category: "Fresh Lime",
    blurb: "Zingy and refreshing, our way.",
    items: [
      { name: "Lime Juice", price: 30 },
      { name: "Mint Lime", price: 40 },
      { name: "Pineapple Lime", price: 40 },
      { name: "Grape Lime", price: 40 },
      { name: "Ginger Lime", price: 40 },
    ],
  },
  {
    category: "Dry Fruit Shake",
    blurb: "Rich, nutty, indulgent — served chilled.",
    items: [
      { name: "Cashew Spice", price: 80 },
      { name: "Dates King", price: 80 },
      { name: "Anjeer Flip", price: 90 },
      { name: "Mixed Dry Fruit", price: 100 },
    ],
  },
];

// Gallery (stock + will grow with user uploads)
export const GALLERY = [
  {
    url: "/assets/storefront.png",
    alt: "mismos cafe storefront",
  },
  {
    url: "/assets/roll-display.png",
    alt: "Fresh roll fillings",
  },
  {
    url: "/assets/roll-hero.png",
    alt: "Signature chicken roll",
  },
  {
    url: "https://images.pexels.com/photos/16825482/pexels-photo-16825482.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    alt: "Chocolate milkshake",
  },
  {
    url: "https://images.unsplash.com/photo-1553787499-6f9133860278?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Iced shake",
  },
  {
    url: "https://images.unsplash.com/photo-1690921822670-5929218ab41d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Mojito closeup",
  },
  {
    url: "https://images.pexels.com/photos/29666244/pexels-photo-29666244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    alt: "Barista in dim light",
  },
  {
    url: "https://images.pexels.com/photos/36570987/pexels-photo-36570987.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    alt: "Gourmet burger",
  },
];
